import Transformer from "../Transformer";
import { i18n } from "../../plugins/vue-i18n";

export default class CounterpartyTypeTransformer extends Transformer {
  static fetch(item) {
    const transformed = {
      typeFullName: item.typeFullName,
      displayName: i18n.t("CONTENT.counterparty." + item.typeFullName)
    };

    return Object.freeze(transformed);
  }
}
